import { render } from "./GeocercaImport.vue?vue&type=template&id=7e97b022"
import script from "./GeocercaImport.vue?vue&type=script&lang=js"
export * from "./GeocercaImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__